import React, { type MouseEvent } from 'react';

import { useNavigate } from 'react-router-dom';

import { SupportedTokens } from '@app/client';
import { type NFTContent } from '@app/store/types/yat-page-actions';

import { NftFloorPrice } from '../NftFloorPrice';

import {
    CollectionWrapper,
    NftDescriptionWrapper,
    StyledCollectionTypography,
    StyledTitleTypography,
    StyledVerificationIcon,
} from './styles';

export interface NftDescriptionProps {
    content: NFTContent;
    disabled: boolean;
    selected?: boolean;
}

export function NftDescription({ content, disabled, selected = false }: NftDescriptionProps) {
    const navigate = useNavigate();
    const handleCollectionClick = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        // TODO add multichain support
        navigate(`/collection/${SupportedTokens.Ethereum}/${content.slug}?goBack=1`);
    };

    return (
        <NftDescriptionWrapper $disabled={disabled}>
            {content.title && (
                <StyledTitleTypography type="headline" size={18} align="left" showEllipsis>
                    {content.title}
                </StyledTitleTypography>
            )}

            {content.collection_name && (
                <CollectionWrapper onClick={handleCollectionClick}>
                    {content.verified && <StyledVerificationIcon $selected={selected} />}

                    <StyledCollectionTypography type="label" size={14} showEllipsis>
                        {content.collection_name}
                    </StyledCollectionTypography>
                </CollectionWrapper>
            )}

            {content.floorPrice && content.floorPrice.value != null && (
                <NftFloorPrice floorPrice={content.floorPrice} selected={selected} />
            )}
        </NftDescriptionWrapper>
    );
}
